import { INFO_EMAIL, SUPPORT_EMAIL, TEAMS_EMAIL } from "../links";
import { WebinarStrip } from "../widgets/employers";
import { usePageTitle } from "./usePageTitle";
import { PageFaq } from "../widgets/PageFaq";

/**
 * Contact (the prototype's `data-s="contact"`, v38): the three team inboxes with the live site's
 * descriptions, and the webinar strip. v38 also has a form, which sends nothing in the prototype;
 * there is no backend for it, so it is left out, and with it the lines that point at it (the
 * lede's "One form" and `contact.direct.*`, kept in site-copy.json for when it exists).
 * Personal addresses are deliberately not listed.
 */
const INBOXES: { title: string; email: string; note: string }[] = [
  { title: "General inquiries", email: INFO_EMAIL, note: "Media requests and general questions." },
  {
    title: "Product support",
    email: SUPPORT_EMAIL,
    note: "Questions about your Abi plan, account access, or technical support.",
  },
  {
    title: "Abi for business",
    email: TEAMS_EMAIL,
    note: "Employer partnerships and business inquiries.",
  },
];

export function ContactPage() {
  usePageTitle("Contact");
  return (
    <div className="spage on" data-s="contact">
      <header className="hero" style={{ paddingBottom: 0 }}>
        <div className="wrap" style={{ maxWidth: 760 }}>
          <h1>Tell us what you need.</h1>
          <p className="lede">
            Go straight to the right inbox. Each one reaches whoever can answer.
          </p>
        </div>
      </header>

      <section className="band tight">
        <div className="wrap" style={{ maxWidth: 860 }}>
          <div className="cmail">
            {INBOXES.map((c) => (
              <div className="cmailc" key={c.email}>
                <p className="mono">{c.title}</p>
                <a href={`mailto:${c.email}`}>
                  {/* a narrow card breaks a long address after the @, not mid-word */}
                  {c.email.split("@")[0]}@<wbr />
                  {c.email.split("@")[1]}
                </a>
                <p>{c.note}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <WebinarStrip />
      <PageFaq page="contact" />
    </div>
  );
}
